import Stats from "three/addons/libs/stats.module.js";

export const createStats = () => {
  const stats = new Stats();
  const panelControls = stats.addPanel(new Stats.Panel("controls", "#0ff", "#002"));
  const panelDiceRoller = stats.addPanel(new Stats.Panel("dice", "#0ff", "#002"));
  const panelStats = stats.addPanel(new Stats.Panel("stats", "#0ff", "#002"));
  const panelRender = stats.addPanel(new Stats.Panel("render", "#0ff", "#002"));
  const panelFrameAnimation = stats.addPanel(new Stats.Panel("animate", "#0ff", "#002"));

  return { panelControls, panelDiceRoller, panelFrameAnimation, panelRender, panelStats, stats };
};

export type DevStats = ReturnType<typeof createStats>;
